import * as moment from 'moment'
import { InvoiceModel } from './invoice.model'
import { AdministrationModel } from './administration.model'
import { LyantheInvoiceModel } from './lyanthe/lyanthe.invoice.model'

export class DocumentModel {
  id: number
  type: string
  status: string
  mime_type: string
  file_name: string
  description: string
  invoice_type: string
  relevance: string
  lyanthe_status: string
  status_reason: string
  status_remarks: string
  created_at: any
  invoice: InvoiceModel
  administration: AdministrationModel
  lyantheInvoice: LyantheInvoiceModel

  constructor(document) {
    {
      this.id = document.id
      this.type = document.type

      if (document.mime_type) {
        this.mime_type = document.mime_type
      }

      if (document.file_name) {
        this.file_name = document.file_name
      }

      if (document.description) {
        this.description = document.description
      }

      if (document.invoice_type) {
        this.invoice_type = document.invoice_type
      }

      if (document.relevance) {
        this.relevance = document.relevance
      }

      if (document.status) {
        this.status = document.status
      }
      if (document.lyanthe_status) {
        this.lyanthe_status = document.lyanthe_status
      }

      if (document.status_reason) {
        this.status_reason = document.status_reason
      }

      if (document.status_remarks) {
        this.status_remarks = document.status_remarks
      }

      if (document.created_at) {
        this.created_at = moment(document.created_at)
      }
      if (document.invoice) {
        this.invoice = new InvoiceModel(document.invoice)
      }

      if (document.administration) {
        this.administration = new AdministrationModel(document.administration)
      }

      this.lyantheInvoice = document.lyanthe_raw ? new LyantheInvoiceModel(document.lyanthe_raw) : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/document.model.ts